export enum DeliveryRecurrenceFrequencyEnum {
    daily = 'DAILY',
    weekly = 'WEEKLY',
    monthly = 'MONTHLY',
    quarterly = 'QUARTERLY'
}
